var React = require('react');

function IcX (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.7919 3.20811C13.0694 3.48559 13.0694 3.93547 12.7919 4.21294L4.21294 12.7919C3.93547 13.0694 3.48559 13.0694 3.20811 12.7919C2.93063 12.5144 2.93063 12.0645 3.20811 11.7871L11.7871 3.20811C12.0645 2.93063 12.5144 2.93063 12.7919 3.20811Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.7919 12.7919C12.5144 13.0694 12.0645 13.0694 11.7871 12.7919L3.20811 4.21294C2.93063 3.93547 2.93063 3.48559 3.20811 3.20811C3.48559 2.93063 3.93547 2.93063 4.21294 3.20811L12.7919 11.7871C13.0694 12.0645 13.0694 12.5144 12.7919 12.7919Z","fill":"currentColor","key":1})]);
}

IcX.defaultProps = {"id":"ic-x","viewBox":"0 0 16 16","fill":"none"};

module.exports = IcX;

IcX.default = IcX;
